import React, { useRef } from "react";
import JoditEditor from "jodit-react";

const Editor = ({ config, value, onChange, ref }) => {
  const editor = useRef(null);
  const contentChange = (content) => {
    onChange(content);
  };
  //
  return (
    <JoditEditor
      className="h-[150px]"
      ref={ref}
      value={value || ""}
      config={config}
      tabIndex={1} // tabIndex of textarea
      onChange={contentChange}
      onBlur={contentChange}
    />
  );
};
export default Editor;
